"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { PageWrapper } from "@/components/core";
import {
  ConnectWalletPrompt,
  FeedbackForm,
} from "@/components/features/feedback";
import { useAuth } from "@/context/auth";

const FeedbackPage = () => {
  const t = useTranslations("feedback");
  const isLoggedIn = useAuth((s) => s.isLoggedIn);

  return (
    <PageWrapper containerClassName="px-4 md:px-6 lg:px-8 pb-28">
      <h1 className="text-lg font-semibold text-text-primary md:text-xl text-center">
        {t("pageTitle")}
      </h1>

      <AnimatePresence mode="wait">
        {isLoggedIn ? (
          <motion.div
            key="form"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
          >
            <FeedbackForm />
          </motion.div>
        ) : (
          <motion.div
            key="connect"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <ConnectWalletPrompt />
          </motion.div>
        )}
      </AnimatePresence>
    </PageWrapper>
  );
};

export default FeedbackPage;
